<template>
  <td v-if="renderCell" class="number-template" :class="[{ editable: isEditable }, className]" @click="$emit('cellclick', { dataItem, field, event: $event })">
    <template v-if="isEditable">
      <el-input ref="cellinput" class="w-full" v-model="localValue" type="number" :precision="precision" :step="step" size="mini" tabindex="0" @change="$emit('change', null, $event)">
        <template v-if="format.includes('percent')" slot="append"><span>%</span></template>
      </el-input>
    </template>
    <template v-else>
      {{ value }} {{extraparams.currencyValue}}
    </template>
  </td>
  <td v-else-if="renderArrow" :key="`g-${columnIndex}`" class="k-group-cell" />
  <td v-else-if="renderGroup" key="g-colspan" class="number-template" :colSpan="columnsCount - columnIndex">
    <p class="k-reset">
      <a @click="$emit('click', $event, dataItem, expanded)" tabIndex="-1" href="#" :class="expanded ? 'k-i-collapse k-icon' : 'k-i-expand k-icon'" />
      {{ groupHeader }}
    </p>
  </td>
</template>
<script>
import { i18n } from '@/i18n'
import { isNumber } from 'lodash'
import getNestedValue from '@/services/functions/getNestedValue'
import { discard } from '@/services/functions/preserve&discard'
import NULL from '@/constants/NULL'

export default {
  name: 'number-template',
  props: {
    tableId: [String, Number],
    field: String,
    dataItem: Object,
    format: String,
    className: String,
    columnIndex: Number,
    columnsCount: Number,
    rowType: String,
    level: Number,
    expanded: Boolean,
    editor: String,
    type: {
      type: String,
      default: 'Text'
    },
    curEditField: [String, null],
    editType: {
      type: [String, Boolean],
      default: 'row'
    },
    editField: {
      type: String,
      default: 'inEdit'
    },
    extraparams: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      localValue: '',
    }
  },
  mounted () {
    this.localValue = this.numericValue
    if (this.isEditable && this.curEditField === this.field && this.$refs.cellinput) {
      this.$refs.cellinput.focus()
    }
  },
  watch: {
    numericValue: function (value, oldValue) {
      if (value !== oldValue) {
        this.localValue = value
      }
    },
    isEditable: function (value, oldValue) {
      if (value && value !== oldValue) {
        this.$nextTick(() => {
          if (this.isEditable && this.curEditField === this.field && this.$refs.cellinput) {
            this.$refs.cellinput.focus()
          }
        })
      }
    }
  },
  computed: {
    renderArrow () {
      var returnValue =
        this.columnIndex === undefined ||
        this.level === undefined ||
        this.columnIndex < this.level ||
        this.columnsCount === undefined ||
        this.rowType !== 'groupHeader' ||
        this.dataItem[this.field] === undefined
      // return returnValue && this.dataItem[this.field]
      return returnValue && this.dataItem[this.field] !== undefined !== undefined
    },
    renderCell () {
      return this.field !== undefined && this.rowType !== 'groupHeader'
    },
    renderGroup () {
      return this.columnIndex <= this.level
    },
    inEdit: function () {
      return getNestedValue(this.editField, this.dataItem) === true
    },
    numericValue: function () {
      const value = getNestedValue(this.field, this.dataItem)
      if ((!value && value !== 0) || value === NULL) {
        return ''
      }
      return Number.parseFloat(getNestedValue(this.field, this.dataItem))
    },
    value: function () {
      return this.formatNumber(this.numericValue)
    },
    maxPrecision: function () {
      const objFormat = i18n.numberFormats[i18n.locale]?.[this.format]
      if (objFormat) {
        return Math.max(objFormat.minimumFractionDigits, objFormat.maximumFractionDigits)
      }
      return 0
    },
    minPrecision: function () {
      const objFormat = i18n.numberFormats[i18n.locale]?.[this.format]
      if (objFormat) {
        return Math.min(objFormat.minimumFractionDigits, objFormat.maximumFractionDigits)
      }
      return 0
    },
    precision: function () {
      const strValue = this.localValue.toString()
      const decimalsLenght = /[.,]/.test(strValue) ? strValue.split(/[.,]/).at(-1).length : 0
      if (decimalsLenght < this.minPrecision) {
        return this.minPrecision
      }
      if (decimalsLenght > this.maxPrecision) {
        return this.maxPrecision
      }
      return decimalsLenght
    },
    step: function () {
      return Math.pow(10, -this.precision)
    },
    groupHeader () {
      const value = this.value
      if (this.rowType === 'groupHeader') {
        const template = this.extraparams.groupHeaderTemplate
        if (typeof template === 'function') {
          return template(this.dataItem, { value, ...discard([template.name], this.extraparams) })
        }
      }
      return value
    },
    editable: function () {
      return !!this.extraparams.editable
    },
    isCellEditable: function () {
      return this.editType === 'cell'
    },
    isEditable: function () {
      return this.editable && this.inEdit && (!this.isCellEditable || this.curEditField === this.field)
    }
  },
  methods: {
    formatNumber: function (strNumber) {
      if (!isNumber(strNumber)) return strNumber
      return i18n.n(strNumber, this.format)
    }
  }
}
</script>

<style scoped>
.bg-success-p{
  background-color: black;
}
.k-grid td.editable {
  text-overflow: clip;
}
.k-grid td.editable::v-deep .el-input__inner {
  min-width: calc(30px + 1em);
}
</style>
